import React from 'react';
import { View } from 'react-native';
import * as API from 'generated/api';
import * as FFObject from 'model/FFObject';
import Chat from 'components/Chat';
import ViewportResponder from 'components/ViewportResponder';
import ChatHeader from 'components/ChatHeader';
import styles from './ChatPage.module.css';
import useClassname from 'utility/useClassname';

type Props = {
  // should we optimize the view for embedding?
  // TODO: break this mode into a different component
  embeddable: boolean;
  chat: API.FFPublicChat;
  objects: Record<string, FFObject.FFObject>;
  fetchObjects: (minY: number, maxY: number) => void;
};

const CHAT_CONTENT_WIDTH = 412;

export function ChatPage({
  chat,
  objects,
  embeddable,
  fetchObjects,
}: Props) {
  useClassname(styles.body, document.body);

  return (
    <View
      style={{
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <ChatHeader chat={chat} />
      <ViewportResponder>
        {(viewportDimensions) => (
          <Chat
            maxWidth={embeddable ? Infinity : CHAT_CONTENT_WIDTH}
            contentWidth={CHAT_CONTENT_WIDTH}
            contentInset={{top: embeddable ? 0 : 80, bottom: 0}}
            viewportSize={viewportDimensions}
            chat={chat}
            objects={objects}
            onViewportChanged={fetchObjects}
          />
        )}
      </ViewportResponder>
    </View>
  );
}

ChatPage.defaultProps = {
  objects: {},
};

export default ChatPage;
